import { createBox } from "../../../../../../packages/web-ui/components/base/Box"
import { RedoitTheme } from "../../theme"

export const Box = createBox<RedoitTheme>()
